import type { JSX } from "react";

import { Skeleton } from "@/components/ui/skeleton";

/** Mid-stream placeholder for ```mermaid fences. Hides incomplete DSL source
 * behind a diagram-sized block until the turn finishes generating. */
export function MermaidStreamingSkeleton(): JSX.Element {
  return (
    <div
      className="my-2 rounded-md border border-border p-3"
      aria-busy="true"
      aria-label="Cargando diagrama"
    >
      <Skeleton className="h-40 w-full" />
    </div>
  );
}
